/**
 * Designer — top-level layout composing Toolbar + NodePalette + Canvas +
 * NodeConfigDrawer + SimulatorPanel.
 */

import { ReactFlowProvider } from "@xyflow/react";
import { Toolbar } from "./Toolbar";
import { Canvas } from "./Canvas";
import { NodeConfigDrawer } from "./NodeConfigDrawer";
import { AddNodeMenu } from "./AddNodeMenu";
import { SimulatorPanel } from "../simulator/SimulatorPanel";
import { RunsPanel } from "../runs/RunsPanel";
import { PageBuilder } from "../builder/PageBuilder";

export function Designer() {
  return (
    <ReactFlowProvider>
      <div className="flex flex-col h-screen">
        <Toolbar />
        <div className="flex-1 min-h-0 flex relative">
          <RunsPanel />
          <Canvas />
          <NodeConfigDrawer />
          <SimulatorPanel />
        </div>
        <PageBuilder />
        <AddNodeMenu />
      </div>
    </ReactFlowProvider>
  );
}
